import React, { FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import { Grid, Typography } from '@rbx/ui';
import { OpenCloudAPIParameter } from '../../../utils/oasTypes';
import ParameterMainTable from './ParameterMainTable';

import useParameterTableStyles from './ParameterTable.styles';

interface ParameterTableProps {
  parameters: OpenCloudAPIParameter[];
}

const ParameterTable: FunctionComponent<React.PropsWithChildren<ParameterTableProps>> = ({
  parameters,
}) => {
  const { translate } = useTranslation();

  const {
    classes: { title },
  } = useParameterTableStyles();

  return (
    <Grid container>
      <Typography className={title} variant='h4' component='h4'>
        {translate('Label.Parameters')}
      </Typography>
      <ParameterMainTable colonBeforeType={false} parameters={parameters} />
    </Grid>
  );
};

export default ParameterTable;
